import type {
  MapCoordinateV1,
  PropertyMapConfigurationV1,
} from "@impetusos/contracts"

import { buildMapboxStaticImageUrl } from "./providers/mapbox-static.js"

export interface PropertyMapPresentation {
  staticImageUrl(
    configuration: PropertyMapConfigurationV1,
    center: MapCoordinateV1,
    zoom: number,
  ): string
}

export const createPropertyMapPresentation = (): PropertyMapPresentation => ({
  staticImageUrl: buildMapboxStaticImageUrl,
})
